<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Categories</div>
      <div>
        <button class="btn btn-secondary btn-sm">Save</button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="category-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Categories</div>
            <div>
              <button class="btn btn-outline-secondary btn-sm" (click)="add()">
                Add
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="each-category" *ngFor="let category of categories">
              <div class="d-flex justify-content-between">
                <span>{{ category }}</span>
                <img src="assets/images/close.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 sm-mt">
        <div class="category-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Subcategories</div>
            <div>
              <button
                class="btn btn-outline-secondary btn-sm"
                modal-trigger="sub"
              >
                Add
              </button>
            </div>
          </div>
          <div class="card-body">
            <div
              class="each-category"
              *ngFor="let subCategory of subCategories"
            >
              <div class="d-flex justify-content-between">
                <span>{{ subCategory }}</span>
                <img src="assets/images/close.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 sm-mt">
        <div class="category-card">
          <div
            class="card-header font18 d-flex justify-content-between align-items-center"
          >
            <div>Topics</div>
            <div>
              <button
                class="btn btn-outline-secondary btn-sm"
                modal-trigger="topic"
              >
                Add
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="each-category" *ngFor="let topic of topics">
              <div class="d-flex justify-content-between">
                <span>{{ topic }}</span>
                <img src="assets/images/close.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
<app-modal
  elementId="sub"
  headerTitle="Add Subcategory"
  centered="true"
  [styles]="{
    modalBodyHeight: '220px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="subCategoryForm">
      <div class="form-row">
        <div class="d-flex justify-content-center mt-5 mb-3 form-group">
          <select class="text-start form-control " formControlName="categoryId">
            <option value="" diabled selected>Select Category</option>
            <option
              value="{{ category.id }}"
              *ngFor="let category of categories"
              >{{ category.name }}</option
            >
          </select>
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input
            type="text"
            class="text-start form-control "
            placeholder="Select Subcategory Name"
            formControlName="name"
          />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button
          class="modalBtn btn-primary"
          type="button"
          [disabled]="subCategoryForm.invalid"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</app-modal>
<app-modal
  elementId="topic"
  headerTitle="Add Topic"
  centered="true"
  [styles]="{
    modalBodyHeight: '280px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <form action="" class="" [formGroup]="topicForm">
      <div class="form-row">
        <div class="d-flex justify-content-center mt-5 mb-3 form-group">
          <select class="text-start form-control " formControlName="categoryId">
            <option value="" diabled selected>Select Category</option>
            <option
              value="{{ category.id }}"
              *ngFor="let category of categories"
              >{{ category.name }}</option
            >
          </select>
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-3 form-group">
          <select class="text-start form-control " formControlName="id">
            <option value="" diabled selected>Select Subcategory</option>
            <option
              value="{{ subCategory.id }}"
              *ngFor="let subCategory of subCategories"
              >{{ subCategory.name }}</option
            >
          </select>
          <span class="text-danger">*</span>
        </div>
      </div>
      <div class="form-row">
        <div class="d-flex justify-content-center mb-4 form-group">
          <input
            type="text"
            class="text-start form-control "
            placeholder="Enter Topic Name"
            formControlName="name"
          />
          <span class="text-danger">*</span>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-3">
        <button
          class="modalBtn btn-primary"
          type="button"
          [disabled]="topicForm.invalid"
        >
          Add
        </button>
      </div>
    </form>
  </div>
</app-modal>
